import { FlexRow, StyledButton, useLoading } from '@gorila-shared-ui/components';
import { Modal, ModalBody, ModalFooter } from 'baseui/modal';
import { createPortal } from 'react-dom';
import { useFeedback } from '../../../../hooks/useFeedback';
import { useStyles } from '../../../../hooks/useStyles';
import { downloadRequest } from '../../../../services/api';
import { Asset } from '../../../../types/asset';
import { StreamingCaptureChannelResponse } from '../../../../types/streaming';
import { downloadBlob } from '../../../../utils/files';
import StreamingCaptureHeader from './StreamingCaptureHeader';

const StreamingFullScreenPreviewModal = ({
  asset,
  source,
  onClose,
  isOpen,
}: {
  asset: Asset;
  source: StreamingCaptureChannelResponse & { url: string };
  onClose: () => void;
  isOpen: boolean;
}) => {
  const { css, theme, classes, concatenateClasses } = useStyles();
  const { startLoading, stopLoading, loading } = useLoading(false);
  const { showFailFeedback } = useFeedback();

  const imageStyles = css({ height: '100%', maxWidth: '100%' });
  const modalBodyStyles = css({ display: 'flex', justifyContent: 'center', flex: 1 });
  const modalFooterStyles = css({
    marginLeft: '0 !important',
    marginRight: '0 !important',
    paddingLeft: theme.sizing.scale800,
    paddingRight: theme.sizing.scale800,
    borderTop: `${theme.borders.border200.borderWidth} ${theme.borders.border200.borderStyle} ${theme.borders.border200.borderColor}`,
  });

  const download = async () => {
    if (!source.key || !source.name) return;
    startLoading();
    const { data, error } = await downloadRequest(source.key);
    if (error) {
      showFailFeedback(error);
    } else if (data) {
      downloadBlob(data.file, source.name);
    }
    stopLoading();
  };

  return createPortal(
    <Modal
      animate
      closeable
      onClose={onClose}
      isOpen={isOpen}
      size="full"
      overrides={{
        Dialog: {
          style: {
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <StreamingCaptureHeader asset={asset} />
      <ModalBody className={modalBodyStyles}>
        <img
          src={source.url}
          className={imageStyles}
          alt="capture_image"
        />
      </ModalBody>
      <ModalFooter className={modalFooterStyles}>
        <FlexRow
          gap={theme.sizing.scale300}
          classNames={concatenateClasses(classes.centeredEnd, css({ maxWidth: '500px', margin: '0 auto' }))}
        >
          <StyledButton
            kind="secondary"
            onClick={onClose}
            full
          >
            Cerrar vista de pantalla completa
          </StyledButton>
          <StyledButton
            onClick={download}
            isLoading={loading}
            full
          >
            Descargar foto
          </StyledButton>
        </FlexRow>
      </ModalFooter>
    </Modal>,
    document.body
  );
};

export default StreamingFullScreenPreviewModal;
